<template>
    <div class="page-container mb-2">
        <div class="is-size-6 has-text-weight-semibold mb-2">
            {{ question.descricao }}
            <span
                v-if="question.obrigatorio"
                class="obrigatorio"
                :title="$t('obrigatorio')"
                >*</span
            >
        </div>
        <div v-if="showAnswer">
            <!-- Verifica se a pergunta é do tipo que precisa de agrupamento -->
            <AnswerComponent
                v-if="multipleOptions.includes(question.item_tipo)"
                :key="question.id"
                :options="question.formRespostaItemList"
                :obrigatorio="question.obrigatorio"
                :tipoPergunta="question.item_tipo"
                :multipleOptions="multipleOptions"
                :isFinalizado="isFinalizado"
            />

            <div v-else>
                <AnswerComponent
                    v-for="answer in question.formRespostaItemList"
                    :key="answer.id"
                    :answer="answer"
                    :obrigatorio="question.obrigatorio"
                    :tipoPergunta="question.item_tipo"
                    :multipleOptions="multipleOptions"
                    :isFinalizado="isFinalizado"
                />
            </div>
        </div>
    </div>
</template>

<script>
import AnswerComponent from "@/components/shared/AnswerComponent.vue";

export default {
    components: {
        AnswerComponent,
    },
    props: {
        question: {
            type: Object,
            default: null,
        },
        isFinalizado: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showAnswer: false,
            multipleOptions: ["RADIO", "CHECKBOX", "COMBOBOX", "SWITCH"],
        };
    },
    created() {
        if (!this.isNull(this.question) && !this.isNull(this.question.formRespostaItemList)) {
            this.question.formRespostaItemList.forEach((formRespostaItem) => {
                let resposta = null;
                if (
                    ["INTEGER", "DECIMAL", "PERCENT"].includes(
                        this.question.item_tipo
                    )
                ) {
                    resposta = 0;
                }
                if (formRespostaItem.formRespostaPreenchida == undefined) {
                    formRespostaItem.formRespostaPreenchida = {
                        id: null,
                        idform_resposta_preenchidaerp: null,
                        uuid: null,
                        uuid_ass_form_resposta_cabecalho_form_pergunta: null,
                        id_form_resposta_item: null,
                        resposta: resposta,
                        situacao: null,
                    };
                } else if (
                    ["INTEGER", "DECIMAL", "PERCENT"].includes(this.question.item_tipo) 
                    && this.isNull(formRespostaItem.formRespostaPreenchida.resposta)
                ) {
                    formRespostaItem.formRespostaPreenchida.resposta = resposta;
                }
            });
            setTimeout(() => {
                this.showAnswer = true;
            }, 500);
        }
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.obrigatorio {
    color: $red;
}
</style>
